export default {
  manage_deletedEquipment: "Equipment was deleted successfully",
  manage_deletedEquipments: "Equipments were deleted successfully",
  manage_deleteManageEquipment_confirmationMessage:
    "Are you sure you want to delete the following Equipments?",
  manage_deleteManageEquipment_deleteEquipment: "Delete Equipment",
  manage_deleteManageEquipment_deleteEquipments: "Delete Equipments",
};
